import {
  SAVE_NEW_TIMER_COUNT_VALUE,
  CHECK_PASSWORD_ERROR,
  SAVE_SOS_COORDS,
  CHECK_PASSWORD,
  SEND_SIGNAL_ABORT,
  START_SOS_SIGNAL_TIMER,
  SOS_SIGNAL_SUCCESS,
  GET_ACTIVE_SIGNALS,
  GET_ACTIVE_SIGNALS_SUCCESS,
  SOS_ACTION_FORBIDDEN,
  CLEAR_SOS_ACTION_FORBIDDEN,
} from '../constants/ActionTypes';

import { SOS_TIMER_VALUE } from '../constants/Values';

const INIT_STATE = {
  loading: false,
  timerCount: SOS_TIMER_VALUE,
  isTimerStarted: false,
  isSosSignalSent: false,
  isPasswordCorrect: true,
  coords: {
    latitude: null,
    longitude: null,
  },
  isActionForbidden: false,
  warningMessage: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case START_SOS_SIGNAL_TIMER: {
      return {
        ...state,
        timerCount: SOS_TIMER_VALUE,
        isTimerStarted: true,
      };
    }

    case SOS_SIGNAL_SUCCESS: {
      return {
        ...state,
        isSosSignalSent: true,
        isTimerStarted: false,
        timerCount: SOS_TIMER_VALUE,
      };
    }

    case SAVE_SOS_COORDS: {
      return {
        ...state,
        coords: {
          latitude: action.payload.latitude,
          longitude: action.payload.longitude,
        },
      };
    }

    case SAVE_NEW_TIMER_COUNT_VALUE: {
      return {
        ...state,
        timerCount: action.payload.timerCount,
      };
    }

    case SEND_SIGNAL_ABORT: {
      return {
        ...state,
        isTimerStarted: false,
      };
    }

    case CHECK_PASSWORD: {
      return {
        ...state,
      };
    }

    case CHECK_PASSWORD_ERROR: {
      return {
        ...state,
        isPasswordCorrect: action.payload.isPasswordCorrect,
      };
    }

    case GET_ACTIVE_SIGNALS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_ACTIVE_SIGNALS_SUCCESS: {
      return {
        ...state,
        isSosSignalSent: action.payload.hasActiveAlarm,
        loading: false,
      };
    }

    case SOS_ACTION_FORBIDDEN: {
      return {
        ...state,
        isActionForbidden: true,
        warningMessage: action.payload.message[0],
      };
    }
    case CLEAR_SOS_ACTION_FORBIDDEN: {
      return {
        ...INIT_STATE,
      };
    }
    default:
      return state;
  }
};
